export function oklchToSRGB(l: number, c: number, h: number): [number, number, number] {
  // Convert hue from degrees to radians.
  const H = (h * Math.PI) / 180;
  const a_ = c * Math.cos(H);
  const b_ = c * Math.sin(H);

  // Convert OKLCH to OKLab.
  const L_ = l + 0.3963377774 * a_ + 0.2158037573 * b_;
  const M_ = l - 0.1055613458 * a_ - 0.0638541728 * b_;
  const S_ = l - 0.0894841775 * a_ - 1.291485548 * b_;

  // Cube the values.
  const L = L_ * L_ * L_;
  const M = M_ * M_ * M_;
  const S = S_ * S_ * S_;

  // Convert to linear sRGB.
  let r = 4.0767416621 * L - 3.3077115913 * M + 0.2309699292 * S;
  let g = -1.2684380046 * L + 2.6097574011 * M - 0.3413193965 * S;
  let b = -0.0041960863 * L - 0.7034186147 * M + 1.707614701 * S;

  // Clamp the values to [0,1].
  r = Math.min(Math.max(r, 0), 1);
  g = Math.min(Math.max(g, 0), 1);
  b = Math.min(Math.max(b, 0), 1);

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
